export default __webpack_public_path__ + "static/media/done-icon.76d0f2b1.webp";